export default __webpack_public_path__ + "static/media/480_dummy2016-sprachunterricht01-mobile-de.f242f0d3.png";